module.exports = __webpack_public_path__ + "media/assets/images/front/img-front-2b-9ba54f149c6b8f2dba50d9f8197bf320.png";